import { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import API from "../../services/api";
import { Toast } from "../../shared/Toast";

const slotPaymentTypeOptions = [
  { value: 1, label: "Prepaid" },
  { value: 2, label: "Postpaid" },
  { value: 3, label: "Partially Paid" },
  { value: 4, label: "Advance" },
];

const paymentSchema = Yup.object().shape({
  id: Yup.number().required("ID is required!"),
  order_id: Yup.string().required("Order ID is required!"),
  order_name: Yup.string().required("Order name is required!"),
  payment_type: Yup.number().required("Payment type is required!").min(1, "Payment type is required").max(4, "Payment type is required"),
  cheque_no: Yup.string().when("payment_type", {
    is: (val) => [1, 3, 4].includes(Number(val)),
    then: (schema) => schema.required("Cheque No / UPI ID is required"),
    otherwise: (schema) => schema.optional(),
  }),
  amount: Yup.number().when("payment_type", {
    is: (val) => [1, 3, 4].includes(Number(val)),
    then: (schema) => schema.typeError("Amount must be a number").required("Amount is required"),
    otherwise: (schema) => schema.optional(),
  }),
});

const EditPaymentDetails = ({ order, onClose }) => {
  const formik = useFormik({
    initialValues: {
      id: order?.id,
      order_id: order?.order_id,
      order_name: order?.order_name,
      payment_type: 0,
      cheque_no: "",
      amount: "",
    },
    validationSchema: paymentSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      const obj = {
        id: values.id,
        order_id: values.order_id,
        order_name: values.order_name,
        payment_details: {
          payment_type: values.payment_type,
          cheque_no: values.cheque_no,
          amount: values.amount,
        },
      };
      const result = await API({
        url: "/order/update-payment-details",
        method: "POST",
        data: obj,
      });
      if (result.status === "SUCCESS") {
        Toast("success", "Payment Details Updated Successfully");
        onClose();
      } else {
        Toast("error", result.data?.message || "Failed to update payment details");
      }
    },
  });
  if (!order || !order.order_id || !order.order_name) return;
  return (
    <div>
      <h6>Edit Payment Details For {order?.order_name}</h6>

      <form onSubmit={formik.handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Order ID</label>
          <input type="text" className="form-control" value={formik.values?.order_id} disabled />
        </div>

        <div className="mb-3">
          <label className="form-label">Order Name</label>
          <input type="text" className="form-control" value={formik.values?.order_name} disabled />
        </div>

        <div className="mb-3">
          <label className="form-label required">Payment Type</label>
          <select className="form-select" name="payment_type" value={formik.values.payment_type} onChange={formik.handleChange} onBlur={formik.handleBlur}>
            <option value={0}>Select Payment Type</option>
            {slotPaymentTypeOptions.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </select>
          {formik.touched.payment_type && formik.errors.payment_type && <div className="text-red-600">{formik.errors.payment_type}</div>}
        </div>

        {[1, 3, 4].includes(Number(formik.values.payment_type)) && (
          <>
            <div className="mb-3">
              <label className="form-label">Cheque No / UPI ID</label>
              <input type="text" className="form-control" name="cheque_no" placeholder="Enter Transaction" value={formik.values.cheque_no} onChange={formik.handleChange} onBlur={formik.handleBlur} />
              {formik.touched.cheque_no && formik.errors.cheque_no && <div className="text-red-600">{formik.errors.cheque_no}</div>}
            </div>

            <div className="mb-3">
              <label className="form-label">Amount</label>
              <input type="text" className="form-control" name="amount" placeholder="Enter Amount" value={formik.values.amount} onChange={formik.handleChange} onBlur={formik.handleBlur} />
              {formik.touched.amount && formik.errors.amount && <div className="text-red-600">{formik.errors.amount}</div>}
            </div>
          </>
        )}

        <button type="submit" className="btn btn-primary">
          Update Payment
        </button>
      </form>
    </div>
  );
};

export default EditPaymentDetails;
